import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import InputMask from 'react-input-mask';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

interface TestSendInputProps {
  onSendTest?: (phoneNumber: string) => void;
}

export function TestSendInput({ onSendTest }: TestSendInputProps) {
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleSendTest = () => {
    if (onSendTest && phoneNumber) {
      const parsed = parsePhoneNumberFromString(phoneNumber, 'US');
      if (parsed) {
        onSendTest(parsed.format('E.164'));
      }
    }
  };

  const isValid =
    phoneNumber.length > 0 && parsePhoneNumberFromString(phoneNumber, 'US')?.isValid();

  return (
    <div className="flex gap-3">
      <div className="w-[260px] flex items-center rounded-md border bg-background focus-within:outline-none">
        <div className="flex items-center gap-1.5 px-3 border-r h-10">
          <span className="text-xs">🇺🇸</span>
          <span className="text-sm">+1</span>
        </div>
        <InputMask
          mask="(999) 999-9999"
          value={phoneNumber}
          onChange={(e) => {
            setPhoneNumber(e.target.value);
          }}
          placeholder="(669) 225-5000"
        >
          {(inputProps: any) => (
            <Input
              {...inputProps}
              className={cn(
                'border-0 h-10',
                'placeholder:text-muted-foreground/50',
                'focus-visible:ring-0 focus-visible:ring-offset-0',
                'focus:outline-none'
              )}
            />
          )}
        </InputMask>
      </div>
      <Button variant="secondary" className="shrink-0" disabled={!isValid} onClick={handleSendTest}>
        Send Test
      </Button>
    </div>
  );
}
